/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../FluxCommon/Actions"], function (require, exports, Actions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var SelectionActions = /** @class */ (function (_super) {
        __extends(SelectionActions, _super);
        function SelectionActions() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        SelectionActions.getKey = function () {
            return "kubernetes-selection-actions";
        };
        SelectionActions.prototype.initialize = function () {
            this._selectItem = new Actions_1.Action();
        };
        Object.defineProperty(SelectionActions.prototype, "selectItem", {
            get: function () {
                return this._selectItem;
            },
            enumerable: true,
            configurable: true
        });
        return SelectionActions;
    }(Actions_1.ActionsHubBase));
    exports.SelectionActions = SelectionActions;
});
